import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { AssetSummary, fetchOverviewCached } from './onboardingTypes';

// Small "Setup 60%" badge for an asset; links into the guided onboarding flow.
const OnboardingProgressBadge: React.FC<{ assetId: number }> = ({ assetId }) => {
  const { currentOrganization } = useAuth();
  const [summary, setSummary] = useState<AssetSummary | null>(null);

  useEffect(() => {
    let alive = true;
    fetchOverviewCached(currentOrganization?.id).then((list) => {
      if (alive) setSummary(list.find((s) => s.asset.id === assetId) || null);
    });
    return () => { alive = false; };
  }, [assetId, currentOrganization?.id]);

  if (!summary) return null;
  const done = !summary.needs_onboarding;
  return (
    <Link
      to={`/onboarding/${assetId}`}
      onClick={(e) => e.stopPropagation()}
      className={`badge text-decoration-none d-flex align-items-center gap-1 ${done ? 'bg-success bg-opacity-10 text-success' : 'bg-primary bg-opacity-10 text-primary'}`}
      title={done ? 'Setup complete — view checklist' : `Setup ${summary.progress.percent}% — continue`}
    >
      <i className={`bi ${done ? 'bi-patch-check' : 'bi-list-check'}`}></i>
      {done ? 'Setup complete' : `Setup ${summary.progress.percent}%`}
    </Link>
  );
};

export default OnboardingProgressBadge;
